import { render } from "./CustomerReview.vue?vue&type=template&id=165e417e&scoped=true"
import script from "./CustomerReview.vue?vue&type=script&lang=js"
export * from "./CustomerReview.vue?vue&type=script&lang=js"

import "./CustomerReview.vue?vue&type=style&index=0&id=165e417e&scoped=true&lang=css"

import exportComponent from "/tmp/build/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-165e417e"]])

export default __exports__